module.exports = __webpack_public_path__ + "static/media/portfolio8-4.1223c137.png";